//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : eliminación de ficha de RRHH

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useState, useEffect, useMemo } from "react";
import {
  Alert,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Snackbar,
  Stack,
  TextField,
  Box,
  Typography,
  DialogContentText,
  DialogActions,
  Autocomplete,
  CircularProgress,
  Card,
  CardActionArea,
} from "@mui/material";
import moment from "moment";
//enviar mails
import { grey } from "@mui/material/colors";
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import Notify from "../../Notify";
import { getData } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";
import BusinessIcon from "@mui/icons-material/Business"; // ícono de edificio
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

function ModalSelectEmpresa(props) {
  const [selectEmpresa, setSelectEmpresa] = useState(props.selectEmpresa);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const style = { backgroundColor: "#ffffff", width: "100%" };
  const [empresas, setEmpresas] = useState();
  const [fichas, setFichas] = useState([]);
  const hoy = new Date();
  const haceUnAnio = new Date();
  haceUnAnio.setFullYear(hoy.getFullYear() - 1);
  const [desde, setDesde] = useState(haceUnAnio.toISOString().split("T")[0]);
  const [hasta, setHasta] = useState(hoy.toISOString().split("T")[0]);
  const [loadingEmpresa, setLoadingEmpresa] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');


  const obtenerEmpresas = () => {
    // getData("/empresas/", setEmpresas);
    const empresasHardcodeadas = [
      { idempresa: 2, empresa: "Italgas" },
      { idempresa: 4, empresa: "Natural Gas" },
    ];
    setEmpresas(empresasHardcodeadas);
  };

  const handleClose = () => {
    setSelectEmpresa(!selectEmpresa);
    if (props.onClose) {
      props.onClose();
    }
  };
  useEffect(() => {
    obtenerEmpresas();
  }, []);
  console.log(empresas);

  const obtenerFichasEmpresa = (empresa) => {
    if (!desde || !hasta) return Promise.resolve([]); // para mantener compatibilidad

    return fetch(
      `${UrlApi}/stock_ficha_rrhh/fichasporempresa/${empresa.idempresa}/${desde}/${hasta}`
    )
      .then((res) => res.json())
      .then((data) => {
        setFichas(data); // opcional, si querés seguir usando el estado
        return data; // <- devolvemos las fichas para que puedan usarse en la siguiente función
      })
      .catch((err) => {
        console.error("Error al obtener fichas:", err);
        return []; // devolvemos array vacío para que el flujo no rompa
      });
  };

  console.log("fichas", fichas);

  const descargarTodasLasFichasEmpresa = async (fichasEmpresa, empresa) => {
    setLoadingEmpresa(true);
    try {
      // Si ya es un array plano, no uses flat()
      const fichasArray = Array.isArray(fichasEmpresa)
        ? fichasEmpresa
        : Object.values(fichasEmpresa).flat();

      // Debug antes del fetch
      console.log("¿Es array?", Array.isArray(fichasArray));
      console.log("Cantidad de fichas:", fichasArray.length);
      console.log("Primer ficha:", fichasArray[0]);

      const response = await fetch(
        `${UrlApi}/generacionfichas/generar-fichas-zip`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          // 👇 corregido: el backend espera fichasEmpresa, no fichasArray
          body: JSON.stringify({ fichas: fichasArray, sucursal: "todas" }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text(); // Leer mensaje del backend si hay
        console.error("Respuesta no OK:", errorText);
        throw new Error("Error en la respuesta del servidor");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `fichas_${moment(Date()).format("YYYY-MM-DD")}_${
        empresa.empresa
      }`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error al descargar:", error);
      alert("Error al generar las fichas");
    } finally {
      setLoadingEmpresa(false);
    }
  };

  const obtenerYDescargarFichasEmpresa = async (empresa) => {
    setLoadingEmpresa(true);
    const fichasObtenidas = await obtenerFichasEmpresa(empresa); // <- ahora sí devuelve algo

    if (!fichasObtenidas || fichasObtenidas.length === 0) {
      setSnackbarMessage("No se encontraron fichas para esta empresa.");
  setSnackbarOpen(true);
  setLoadingEmpresa(false);
  return;
    }

    await descargarTodasLasFichasEmpresa(fichasObtenidas, empresa);
  };

  return (
    <div>
      <Dialog
        open={selectEmpresa}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        {notificacion.open && (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => props.onClose(false)}
            severity={notificacion.severity}
          />
        )}
        <Box mt={1} backgroundColor={"#1F618D"}>
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Descargar Fichas por empresa
            </Typography>
          </DialogTitle>
        </Box>
        <Box
          border={0.5}
          borderColor={grey[300]}
          backgroundColor="#F4F6F6"
          p={2}
          py={2}
          mt={1}
        >
          <DialogContent>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={3}
              gap={2}
              flexWrap="wrap"
            >
              <TextField
                focused
                size="small"
                label="Desde"
                type="date"
                value={desde}
                onChange={(e) => setDesde(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                type="date"
                value={hasta}
                onChange={(e) => setHasta(e.target.value)}
                focused
                size="small"
                label="Hasta"
                InputLabelProps={{ shrink: true }}
              />
            </Box>

            <Grid container spacing={2} justifyContent={"center"}>
              {loadingEmpresa ? (
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 200 }}>
                     <Box sx={{ textAlign: "center" }}>
                       <CircularProgress color="primary" />
                       <Typography mt={2} color="textSecondary">Generando fichas...</Typography>
                     </Box>
                   </Grid>
              ) : (
                empresas?.map((empresa) => (
                  <Grid item xs={12} sm={6} md={4} key={empresa.idempresa}>
                    <Card
                      sx={{
                        borderRadius: "10px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        transition: "all 0.2s ease",
                        border: "1px solid #e0e0e0",
                        height: "100%",
                        "&:hover": {
                          transform: "translateY(-3px)",
                          boxShadow: "0 6px 12px rgba(0,0,0,0.12)",
                          borderColor: "#1F618D",
                        },
                      }}
                    >
                      <CardActionArea
                        onClick={() => obtenerYDescargarFichasEmpresa(empresa)}
                        sx={{
                          p: 2,
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "50%",
                            bgcolor: "#ebf5fb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mb: 1.5,
                          }}
                        >
                          <CloudDownloadIcon
                            sx={{ fontSize: 24, color: "#1F618D" }}
                          />
                        </Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight="600"
                          textAlign="center"
                          color="#1F618D"
                          sx={{
                            fontFamily: "'Roboto', sans-serif",
                            letterSpacing: "0.3px",
                            lineHeight: "1.3",
                          }}
                        >
                          {empresa.empresa}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="#5D6D7E"
                          mt={0.5}
                          textAlign="center"
                          display="block"
                        >
                          Descargar fichas
                        </Typography>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))
              )}
            </Grid>
          </DialogContent>
        </Box>
        <Snackbar
  open={snackbarOpen}
  autoHideDuration={2000}
  onClose={() => setSnackbarOpen(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

      </Dialog>
    </div>
  );
}

export default ModalSelectEmpresa;
